/**
 * When a clipboard's contents are gone and when they start coming back:
 * erased over the first part of the cycle, a beat with the board bare, then
 * written in again.
 */export const CLIPBOARD_TIMING={erasedBy:0.4,drawingFrom:0.55};